export default __webpack_public_path__ + "static/media/calendar.ca4d106c.svg";